module.exports = __webpack_public_path__ + "289bbd53b9c26ca220432c60911a26e4.jpg";